import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import { encodeOpenMetadataFqn } from '@/shared/lib/format';

export type FileItem = {
  name: string;
  type: 'file' | 'folder';
  size?: number;
  lastModified?: string;
  path: string;
  mimeType?: string;
};

export type FilesResponse = {
  files: FileItem[];
  totalCount: number;
};

type ContainerChild = {
  id: string;
  name: string;
  displayName?: string;
  fullyQualifiedName: string;
  dataModel?: {
    columns?: Array<{
      name: string;
      dataType?: string;
    }>;
  };
  numberOfObjects?: number;
  size?: number;
  fileFormats?: string[];
};

type ContainerChildrenResponse = {
  data: ContainerChild[];
  paging?: {
    total: number;
  };
};

const transformContainerChildrenToFiles = (children: ContainerChild[], currentPath: string): FilesResponse => {
  const files: FileItem[] = children.map((child) => {
    const childName = child.displayName || child.name;
    const fullPath = currentPath ? `${currentPath}/${childName}` : childName;

    const isFolder = child.numberOfObjects !== undefined;

    return {
      name: childName,
      type: isFolder ? 'folder' : 'file',
      size: child.size,
      path: fullPath,
      mimeType: child.fileFormats?.[0],
    };
  });

  return {
    files,
    totalCount: files.length,
  };
};

export const fetchContainerFiles = async (containerFqn: string, currentPath: string = ''): Promise<FilesResponse> => {
  try {
    const targetFqn = currentPath ? `${containerFqn}.${currentPath.replace(/\//g, '.')}` : containerFqn;
    const encodedFqn = encodeOpenMetadataFqn(targetFqn);

    const response = await openMetadataApiClient.get<ContainerChildrenResponse>(
      `/containers/name/${encodedFqn}/children`,
      {
        params: { limit: 0 },
      }
    );

    return transformContainerChildrenToFiles(response.data.data || [], currentPath);
  } catch (error) {
    console.error('Failed to fetch container files:', error);
    throw error;
  }
};
